module.exports = __webpack_public_path__ + "img/appl.597c75b2.svg";